import { getWebSocket } from '@/utils/ws'

class WebSocketManager {
  constructor() {
    this.ws = getWebSocket()
    this.isInitialized = false
    this.messageHandlers = new Map()
  }
  // 初始化WebSocket（仅建立连接，不登录）
  init() {
    if (this.isInitialized && this.ws.isConnected()) return Promise.resolve();
    this.setupEventListeners()
    return this.ws.init().then(() => {
      this.isInitialized = true
      console.log('WebSocket管理器初始化完成')
    }).catch(error => {
      console.error('WebSocket初始化失败:', error)
    })
  }
  // 设置事件监听
  setupEventListeners() {
    // 监听未授权事件
    this.ws.on('unauthorized', () => {
      console.log('WebSocket token失效')
    })
    // 监听登录成功
    this.ws.on('login_success', () => {
      console.log('WebSocket登录成功')
    })
    // 监听连接关闭
    this.ws.on('close', () => {
    })
    // 监听重连失败
    this.ws.on('reconnect_failed', () => {
      console.error('WebSocket重连失败')
    })
    // 监听消息
    this.ws.on('message', (message) => {
      if (message.typeStr === 'RELOAD_NOTICE') {
        const handler = this.messageHandlers.get('reloadNotice')
        if (handler) {
          handler(message)
        }
      }
    })
  }
  // 注册消息类型处理器
  onMessageType(type, handler) {
    this.messageHandlers.set(type, handler)
  }
  offMessageType(type) {
    this.messageHandlers.delete(type)
  }
  // 登录WebSocket
  async login(token) {
    if (!this.isInitialized) {
      return this.init().then(() => {
        this.ws.setToken(token)
      })
    }
    this.ws.setToken(token)
    return true
  }
  // 登出WebSocket
  logout() {
    this.ws.logout()
    this.ws.close()
    this.isInitialized = false
  }
  // 获取连接状态
  isConnected() {
    return this.ws.isConnected()
  }
  // 是否已登录
  isLogin() {
    return this.ws.isLogin()
  }
}

// 创建单例
const wsManager = new WebSocketManager()

export default wsManager